// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"283":"f2006760","322":"570defff","479":"2e7959a8","653":"57e1a1f9"}[chunkId] + ".css";
};